import TileMinedLogic from "../../../logic/TileMinedLogic";
import Character from "../../character/Character";
import { CharacterAction } from "../../character/CharacterAction";
import GridTile from "../../grid/GridTile";
import PathPlanWalkLeft from "./PathPlanWalkLeft";

export default class PathPlanMineAndWalkLeft extends PathPlanWalkLeft {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     * @param {TileMinedLogic} tileMinedLogic
     */
    constructor(startTile, endTile, pathSteps, tileMinedLogic) {
        super(startTile, endTile, pathSteps);

        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;

        /**
         * @type {boolean}
         */
        this.miningThisTurn = false;
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        // The miner is on the start tile.
        // The end tile is always the neighbor tile to the start tile.

        if (!this.endTile.open) {
            // Mine the tile
            character.setCharacterAction(CharacterAction.MINE);

            this.miningThisTurn = true;

            // Set the direction
            if (character.position.worldCoordinateOrigin.x !== this.endTile.origin.x) {
                character.position.facingLeft = character.position.worldCoordinateOrigin.x > this.endTile.origin.x;
            }

            // We only actually do mining once per turn.
            if (!turnStart) {
                return false;
            }

            // The endTile is the target or our mining.
            this.tileMinedLogic.mineTileForTurn(character, this.endTile);
            
            // If we mined this turn, then don't execute the rest of the plan even if we have finished
            // mining the tile.  The super class will cancel our character action and mess up the animation.
            return false;
        }
        else if (this.miningThisTurn) {
            // If we did some mining, then don't start walking until the next turn begins.
            if (turnStart) {
                this.miningThisTurn = false;
            }
            else {
                return false;
            }
        }

        return super.executePlan(character, frameTimeRatio, turnStart);
    }
   
    /**
     * @returns {String}
     */
    toString() {
        return 'MineAndWalkLeft(' + this.pathSteps + ')';
    }
}